import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanActivateFn, Router } from '@angular/router';
import { InfoDialogComponent } from '@shared/components/ui/dialogs/info-dialog/info-dialog.component';
import { DIALOG_TITLES } from '@shared/constants/dialog-titles';
import { DossierService } from '@shared/services/cabinet/dossier.service';
import { map } from 'rxjs';

export const hasExerciceComptableGuard: CanActivateFn = () => {
  const dossierService = inject(DossierService);
  const dialog = inject(MatDialog);
  const router = inject(Router);
  if (dossierService.hasExerciceComptable) {
    return true;
  }

  return dossierService.get(dossierService.dossierId).pipe(
    map((dossier) => {
      const { dateDebutExercice, dateFinExercice } = dossier;
      if (!!dateDebutExercice && !!dateFinExercice) {
        return true;
      }
      dialog.open(InfoDialogComponent, {
        data: {
          title: DIALOG_TITLES.WARNING,
          msg: "Ce module nécessite une date de début et de fin d'exercice.",
        },
      });
      router.navigate([`dossier/${dossierService.dossierId}/accueil`]);
      return false;
    }),
  );
};
